import React from 'react';
import { Loading, EmptyState, Button } from '../../../components';
import { LINK_SESSION_STATUS } from '../../../hooks/useAgendeaiLinkSession';
import { LINK_EXPIRED_MESSAGE } from '../../../utils/linkSession';

function LinkSessionStatus({ status, expiredDescription, onRetryPress }) {
	if (status === LINK_SESSION_STATUS.LINK_EXPIRED) {
		return (
			<EmptyState
				icon="link-slash"
				title={LINK_EXPIRED_MESSAGE}
				description={expiredDescription}
			/>
		);
	}

	if (status === LINK_SESSION_STATUS.LOAD_ERROR) {
		return (
			<>
				<EmptyState
					icon="alert-circle"
					title="Não foi possível carregar a página."
					description="Verifique sua conexão e tente novamente."
				/>
				<Button block size="large" type="button" onClick={onRetryPress}>
					Tentar novamente
				</Button>
			</>
		);
	}

	return <Loading />;
}

export default LinkSessionStatus;
